import { render, staticRenderFns } from "./ClientCourseActions.vue?vue&type=template&id=6b44c256&"
import script from "./ClientCourseActions.vue?vue&type=script&lang=js&"
export * from "./ClientCourseActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports